import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface ApiLoadErrorState {
  source: string;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class ApiLoadErrorService {
  private readonly state$ = new BehaviorSubject<ApiLoadErrorState | null>(null);
  private lastSignature: string | null = null;

  get changes(): Observable<ApiLoadErrorState | null> {
    return this.state$.asObservable();
  }

  report(source: string, message: string): void {
    const signature = `${source}:${message}`;
    if (this.lastSignature === signature) {
      return;
    }

    this.lastSignature = signature;
    this.state$.next({ source, message });
  }

  clear(): void {
    this.lastSignature = null;
    this.state$.next(null);
  }
}
